export default class GraphPaginationService {
  public static findStartToEnd(
    currentPage: number,
    totalPages: number,
    total: number,
    rowsPerPage: number,
  ): { start: number; end: number } {
    if (!totalPages || !total || currentPage <= 0 || rowsPerPage <= 0) {
      return { start: 0, end: 0 };
    }

    const clampedPage = Math.min(Math.max(currentPage, 1), totalPages);
    const start = Math.max(0, (clampedPage - 1) * rowsPerPage);
    const end = clampedPage === totalPages ? total : Math.min(total, start + rowsPerPage);

    return { start, end };
  }
}
